'use strict';

var EventsHandler = require('./EventsHandler');

var Util = {
    _objectExistsType: new Array(),

    //TODO: At this time we are unable to get rid of this code, as much as I'd like to do so.  The code is currently only used in one place (Chart.js).
    //However, we're unable to tackle this until an issue pertaining to improperly saving cookies.  This code exists primarily to only render the sidebar
    //dashboards once the user actually opens the sidebar dashboard on login.  However, the benefits that we get from skipping a render are being weighed
    //against the amount of code that can be removed by getting rid of this function.
    addElementVisibleEvent: function(elementID, event, timeout){
        Util._addObjectExistsEvent('Element', elementID, event, function(){
            var $element = jQuery('#' + elementID);
            return $element.length > 0 && $element.width() > 0;
        }, timeout);
    },

    _addObjectExistsEvent: function(type, object, eventFunction, checkFunction, timeout){
        if(Util._objectExistsType[type] == null){
            Util._objectExistsType[type] = new Util.ObjectExistsType(checkFunction);
        }

        Util._objectExistsType[type].addEvent(object, eventFunction, timeout);
    }
};

// Private Class
Util.ObjectExistsType = function(checkFunction) {
    this.initialize(checkFunction);
};

Util.ObjectExistsType.prototype = {
    _intervalIds: null,
    _eventHandlers: null,
    check: null,

    initialize: function(checkFunction){
        this._intervalIds = new Array();
        this._eventHandlers = new Array();
        this.check = checkFunction;
    },

    addEvent: function(object, event, timeout){
        if(this._eventHandlers[object] != null){
            this._eventHandlers[object].addEvent(event);
            return;
        }

        if(timeout == null) {
            timeout = 250;
        }

        this._eventHandlers[object] = new EventsHandler();
        this._eventHandlers[object].addEvent(event);

        this._intervalIds[object] = window.setInterval(function(){
            if(this.check(object)){
                window.clearInterval(this._intervalIds[object]);
                this._eventHandlers[object].executeEvents();

                this._intervalIds[object] = null;
                this._eventHandlers[object] = null;
            }
        }.bind(this), timeout);
    }
};

module.exports = Util;


//////////////////
// WEBPACK FOOTER
// ./mits/Events/Util.js
// module id = 13
// module chunks = 0